import React from 'react';

import Link from 'next/link';

import { PrimaryButton } from '@/components/Button/PrimaryButton';
import useMediaQuery from '@/hooks/useMediaQuery';
import GitCoinIcon from 'public/assets/gitcoin.png';
import GitHubIcon from 'public/assets/github_logo.png';
import MailIcon from 'public/assets/mail.png';
import MainLogo from 'public/assets/mainLogo.png';
import TwitterIcon from 'public/assets/twitter.png';

export const MoreTab = () => {
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');
  const icons = [
    {
      icon: TwitterIcon.src,
      title: 'Twitter',
      link: 'https://twitter.com/fileverseio',
    },
    {
      icon: GitHubIcon.src,
      title: 'Github',
      link: 'https://github.com/fileverse',
    },
    {
      icon: GitCoinIcon.src,
      title: 'Gitcoin',
      link: 'https://gitcoin.co/grants/4846/fileverseio-file-sharing-between-blockchain-addre',
    },
    {
      icon: MailIcon.src,
      title: 'Email',
      link: 'mailto:hello@fileverse.io',
    },
  ];

  return (
    <div className="text-center flex flex-col justify-center items-center py-2 p-4">
      <div className="flex items-start">
        <img
          alt=""
          src={MainLogo.src}
          className={isMediaMax1025px ? 'w-[40px]' : 'w-[20px]'}
        />
        <span
          className={`ml-2 text-justify font-semibold ${
            isMediaMax1025px ? 'text-xs' : 'text-sm'
          }`}
        >
          Fileverse is a decentralised collaboration and file sharing app.
          Upload, create, store, and encrypt any type of file.{' '}
          <a
            href="https://fileverse.io/"
            target="_blank"
            className="text-blue-700"
            rel="noreferrer"
          >
            Learn more
          </a>
        </span>
      </div>
      <div className="mt-4 mb-8 flex items-start">
        <img
          alt=""
          src={MainLogo.src}
          className={isMediaMax1025px ? 'w-[40px]' : 'w-[20px]'}
        />
        <span
          className={`ml-2 text-justify font-semibold ${
            isMediaMax1025px ? 'text-xs' : 'text-sm'
          }`}
        >
          Regain your privacy and discover new ways of coordinating with people
          via a simple solution that combines peer-to-peer file sharing networks
          (IPFS and Arweave), end-to-end encryption, multisignatures, and public
          blockchains like Ethereum.
        </span>
      </div>

      <PrimaryButton onClick={() => {}}>
        <Link href="/">Share my files</Link>
      </PrimaryButton>
      <div className="font-semibold mb-6 mt-4 text-lg">Where to find Us ?</div>
      <div className="flex mb-4">
        {icons.map((icon) => (
          <div className="mr-2 items-center flex-col flex" key={icon.title}>
            <a href={icon.link} className="bg-[#fef08a] rounded-xl  p-2">
              <img src={icon.icon} alt="" className="h-5" />
            </a>
            <a className="text-xs mt-1">{icon.title}</a>
          </div>
        ))}
      </div>
    </div>
  );
};
export default MoreTab;
